<div class="ui-result-widget__actions">
  <ng-content select="campus-result-widget-actions"></ng-content>
</div>
<div class="ui-result-widget__content" #content>
  @if (chartOverflow) {
    <campus-icon
      class="ui-result-widget__overflow"
      svgIcon="zoom-in"
      (click)="clickExpandOverflow.emit($event)"
    ></campus-icon>
  }
  <ng-content select="campus-result-widget-content"></ng-content>
</div>

<div class="ui-result-widget__label">
  <ng-content select="campus-result-widget-label"></ng-content>
</div>
